import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  undo: [],
  redo: [],
  resumes: { items: [] },
  currentResume: undefined,
  metrics: {},
  templates: [],
  activeColorPalette: {},
  contacts: [],
  fetchingData: {}, // key is type of data and value boolean
  loading: false,
  savingResume: '',
  emailNotification: null,
  currentMode: 'preview',
  leftPannelWidth: localStorage.getItem('panelSize') ? Number(localStorage.getItem('panelSize')) : 320,
  searchResult: { items: [] },
  resetSearch: new Date().getTime(),

  batchId: '',
  batchInfo: null,
  fetchingBatchError: false,

  lastTemplateOptions: null,
  lastOrganizationId: null,
};

const namespaced = false;
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced,
};
